import Helper from '../riHelper';
import { every, filterFor, lookFor } from '../central/enumerableExtensions';
import CacheLayer from '../central/services/cacheLayer';
import Promise from 'bluebird';
import { TaxonomyHelper } from './TaxonomyHelper';
var TermNaviService = (function () {
    function TermNaviService(termSetId) {
        this.termSetId = termSetId;
    }
    TermNaviService.start = function (termSetId) {
        var svc = TermNaviService.instances[termSetId];
        if (!svc) {
            svc = TermNaviService.instances[termSetId] = new TermNaviService(termSetId);
        }
        return svc;
    };
    TermNaviService.prototype.getCurrentTermPath = function () {
        var m = window.location.search.match(/(?:\?|&)term=(.+?)(?:&|$)/);
        if (m) {
            var termName = decodeURIComponent(m[1].replace(/\+/g, '%20'));
            if (termName.indexOf(';') > 0) {
                return termName.split(';');
            }
            else {
                return [termName];
            }
        }
        return [];
    };
    TermNaviService.prototype.loadTermItemsOfTermSet = function () {
        var _this = this;
        return this.loadTermSet().then(function (termSet) {
            var terms = termSet.get_terms();
            return _this.parseToTermItems(terms, termSet);
        });
    };
    TermNaviService.prototype.parseToTermItems = function (terms, termSet) {
        var _this = this;
        var result = [];
        every(terms, function (t) {
            if (t.get_isAvailableForTagging()) {
                var item = _this.parseToTermItem(t, termSet);
                if (item) {
                    result.push(item);
                }
            }
        });
        return result;
    };
    TermNaviService.prototype.parseToTermItem = function (term, termSet) {
        if (!term) {
            return null;
        }
        var localProps = term.get_localCustomProperties();
        var customProps = term.get_customProperties();
        var exclude = (localProps['_Sys_Nav_ExcludedProviders'] || '').indexOf('CurrentNavigationTaxonomyProvider') > -1;
        exclude = exclude || !!(customProps['Versteckt'] || false);
        if (exclude) {
            return null;
        }
        return {
            id: term.get_id().toString(),
            title: TaxonomyHelper.tryGetLabelWithHyphen(term),
            path: term.get_pathOfTerm(),
            url: localProps['_Sys_Nav_SimpleLinkUrl'] || '#',
            icon: customProps['SVG'] || '',
            description: term.get_description(),
            hoverText: localProps['_Sys_Nav_HoverText'] || '',
            termSetId: termSet.get_id().toString()
        };
    };
    TermNaviService.prototype.loadTermSet = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Helper.taxSession()
                .then(function (_a) {
                var tax = _a.tax, termStore = _a.termStore;
                var ctx = tax.get_context();
                var termSet = termStore.getTermSet(new SP.Guid(_this.termSetId));
                ctx.load(termSet);
                var terms = termSet.get_terms();
                ctx.load(terms);
                Helper.clientContextExecute(ctx).then(function () {
                    resolve(termSet);
                });
            })
                .catch(reject);
        });
    };
    TermNaviService.prototype.loadTermItemsOfTerm = function (termPath) {
        var _this = this;
        return CacheLayer.simpleLoad(function () {
            if (!termPath || !termPath.length) {
                return _this.loadTermItemsOfTermSet();
            }
            return _this.loadTermByName(termPath, true).then(function (_a) {
                var term = _a.term, termSet = _a.termSet;
                if (!term) {
                    return null;
                }
                var ctx = term.get_context();
                var terms = term.get_terms();
                ctx.load(terms);
                return Helper.clientContextExecute(ctx).then(function () {
                    return _this.parseToTermItems(terms, termSet);
                });
            });
        }, "termNavi-children-" + (termPath || []).join('-'));
    };
    TermNaviService.prototype.loadTermItem = function (termPath) {
        var _this = this;
        if (!termPath || termPath.length == 0) {
            return Promise.resolve(null);
        }
        return CacheLayer.simpleLoad(function () {
            return _this.loadTermByName(termPath, true).then(function (_a) {
                var term = _a.term, termSet = _a.termSet;
                return _this.parseToTermItem(term, termSet);
            });
        }, "termNavi-item-" + (termPath || []).join('-'));
    };
    TermNaviService.prototype.loadTermByName = function (termPath, tryFindInSubTerms) {
        if (tryFindInSubTerms === void 0) { tryFindInSubTerms = false; }
        if (!termPath || !termPath.length) {
            return Promise.resolve({ term: null, termSet: null });
        }
        return this.loadTermSet().then(function (termSet) {
            var ctx = termSet.get_context();
            var terms = termSet.get_terms();
            var termPathString = termPath.join(';');
            var rootTerm = lookFor(terms, function (t) { return t.get_pathOfTerm() == termPathString; });
            if (!rootTerm && tryFindInSubTerms) {
                var allTerms_1 = termSet.getAllTerms();
                ctx.load(allTerms_1);
                return Helper.clientContextExecute(ctx).then(function () {
                    var subTerms = filterFor(allTerms_1, function (t) { return t.get_pathOfTerm().endsWith(termPathString); }).sort(function (a, b) {
                        return a.get_pathOfTerm() < b.get_pathOfTerm() ? -1 : a.get_pathOfTerm() > b.get_pathOfTerm() ? 1 : 0;
                    });
                    if (subTerms.length) {
                        console.log('subTerms', subTerms.map(function (t) { return t.get_pathOfTerm(); }));
                        return { term: subTerms[0], termSet: termSet };
                    }
                    return Promise.resolve({ term: null, termSet: null });
                });
            }
            else {
                return { term: rootTerm, termSet: termSet };
            }
        });
    };
    TermNaviService.prototype.loadTerm = function (termId) {
        return this.loadTermSet().then(function (termSet) {
            var ctx = termSet.get_context();
            var term = termSet.getTerm(termId);
            ctx.load(term);
            return Helper.clientContextExecute(ctx).then(function () {
                return term;
            });
        });
    };
    TermNaviService.prototype.loadTermCustomPropertyDescByTermId = function (termId, propertyName) {
        var _this = this;
        return CacheLayer.simpleLoad(function () {
            return _this.loadTerm(new SP.Guid(termId)).then(function (term) {
                return _this.loadTermCustomPropertyDescByTerm(term, propertyName);
            });
        }, "termCustProperty-" + termId + "-" + propertyName);
    };
    TermNaviService.prototype.loadTermCustomPropertyDescByTerm = function (term, propertyName) {
        var _this = this;
        var termProperties = term.get_customProperties();
        var propertyValue = termProperties[propertyName];
        if (propertyValue) {
            return Promise.resolve(propertyValue);
        }
        else {
            var parent_1 = term.get_parent();
            var ctx_1 = term.get_context();
            ctx_1.load(parent_1);
            return new Promise(function (resolve) {
                Helper.clientContextExecute(ctx_1).then(function () {
                    if (!parent_1.get_serverObjectIsNull()) {
                        resolve(_this.loadTermCustomPropertyDescByTerm(parent_1, propertyName));
                    }
                    else {
                        resolve(null);
                    }
                });
            });
        }
    };
    TermNaviService.instances = {};
    return TermNaviService;
}());
export { TermNaviService };
